import React from 'react'
import { TypeAnimation } from 'react-type-animation'

const TextEffect = () => {
  return (
    <TypeAnimation sequence={[
        'Data Scientist',
        1500,
        'ML Engineer',
        1500,
        'Backend Developer',
        1500,
        'Programmer',
        1500,
    ]}
    speed={50} className='block text-[22px] md:text-[28px] text-[#55e6a5] font-medium leading-tight tracking-[-0.01em] mt-3 min-h-[1.3em]'
    repeat={Infinity} />
  );
};

export default TextEffect
